import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
export default class extends Controller {
  static #_ = (() => dt7948.g(this.prototype, "tagName", [tracked], function () {
    return null;
  }))();
  #tagName = (() => (dt7948.i(this, "tagName"), void 0))();
}